import React, { useState } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/Login/Index";
import { validateAll } from "indicative/validator";
import ToastAlert from "../common/ToastAlert";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, setLogin, setEmailVerified } from "../redux/user/user.action";
import { setVisitedList } from "../redux/global/global.action";
import ApiCall from "../common/ApiCall";
import { getSlugByLang } from "../common/Helper";

export default function LoginController() {

    const [state, setState] = useState({
        email: "",
        password: "",
        error: [],
    })
    const [showPassword, setShowPassword] = useState(false);

    const { email, password } = state;
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const global = useSelector((state) => state.global);
    const user = useSelector((state) => state.user);
    const userlang = getSlugByLang(user?.language);


    const storeUserProductVisit = async (data, token) => {
        const storeVisit = await ApiCall('post', 'store-product-visit', { visitedList: data, type: 'LOCAL' }, token)
    }

    const login = (e) => {
        if (isLoading) {
            return;
        }
        e?.preventDefault();
        setState({
            ...state,
        })

        const rules = {
            email: 'required|email',
            password: 'required|min:6',

        }

        const message = {
            'email.required': 'Email is Required.',
            'email.email': 'please enter valid email.',
            'password.min': 'The password must contain a minimum of 6 characters.',
            'password.required': 'Password is Required.',

        }
        validateAll(state, rules, message).then(async () => {
            setIsLoading(true)
            setState({
                ...state,
                error: {}
            })
            let data = {}
            data.email = email
            data.password = password

            const authenticate = await ApiCall('post', 'login', data)

            if (authenticate) {

                if (authenticate?.data?.success) {
                    let dispatchData = {}
                    dispatchData.userDetails = authenticate.data.user
                    dispatchData.token = authenticate.data.access_token
                    dispatchData.tempEmail = authenticate.data.user.email

                    dispatch(setLogin(dispatchData))
                    if (global.visitedList) {
                        await storeUserProductVisit(global.visitedList, authenticate.data.access_token)
                    }
                    dispatch(setVisitedList(null))

                    if (authenticate.data.user.email_verified_at == "" || authenticate.data.user.email_verified_at == null) {
                        dispatch(setEmailVerified(false))
                        ToastAlert({ msg: 'Please verify otp that we sent you in email', msgType: 'info' });
                        navigate('/' + userlang + '/verify')
                    } else {
                        ToastAlert({ msg: authenticate.data.message, msgType: 'success' });
                        dispatch(setEmailVerified(true))
                        navigate('/' + userlang + '/home')
                        setIsLoading(false)
                    }
                } else {

                    if (authenticate?.data?.errors && Object.keys(authenticate?.data?.errors).length) {

                        setState({
                            ...state,
                            error: authenticate?.data?.errors,
                        })

                    } else {
                        // ToastAlert({ msg: authenticate.data.message, msgType: 'error' });
                        const formaerrror = {};
                        formaerrror.email = authenticate?.data?.message
                        setState({
                            ...state,
                            error: formaerrror,
                        })
                    }
                    setIsLoading(false)

                }
            } else {
                setIsLoading(false)
                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
            }





        }).catch(errors => {
            setIsLoading(false)
            const formaerrror = {};
            if (errors.length) {
                errors.forEach(element => {
                    formaerrror[element.field] = element.message
                });
            } else {
                ToastAlert({ msg: errors?.message ?? 'Something went wrong', msgType: 'error' });
            }

            setState({
                ...state,
                error: formaerrror,
            })

        });

    }

    const changeValue = (e) => {
        let value = e.target.value;
        setState({
            ...state,
            [e.target.name]: value
        })
    }

    const handhandleShowPassword = (e) => {
        e?.preventDefault();
        setShowPassword(!showPassword)
    }


    return (
        <>
            <PageTitle title={'Login'} />
            <Index
                state={state}
                login={login}
                changeValue={changeValue}
                showPassword={showPassword}
                handhandleShowPassword={handhandleShowPassword}
                isLoading={isLoading}
                userlang={userlang}
            />
        </>
    )

}